import { Component, OnInit, HostListener, OnDestroy } from '@angular/core';
import { GuestBiometricService } from './guest-biometric.service';
import { catchError, switchMap } from 'rxjs/operators';
import { throwError } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { UnsubscribableComponent } from '@app/shared/unsubscribable/unsubscribable.component';
import { finalize, takeUntil, map, tap, take } from 'rxjs/operators';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { MatRadioChange } from '@angular/material/radio';
import { AuthenticationService } from '@app/services/authentication.service';
import { DisclosuresService, ICreateDisclosureResponse } from '@app/services/disclosures.service';
import { NotificationService } from '@app/notification-module/services/notification.service';

type GuestStep = 'loading' | 'id-screening' | 'disclosure-signing' | 'done';

interface TCompanyData {
  id: number;
  name: string;
  logoName: string;
}

interface TToken {
  accessToken: string;
  user: Record<string, string>;
  company: TCompanyData;
}

@Component({
  standalone: false,
  selector: 'app-guest-biometric',
  templateUrl: './guest-biometric.component.html',
  styleUrls: ['./guest-biometric.component.css'],
})
export class GuestBiometricComponent extends UnsubscribableComponent implements OnInit, OnDestroy {
  public link: SafeResourceUrl = null;
  private readonly _successMessage = 'verifiedPage';
  private _operationId: string = null;
  code: string;
  role: string;
  error: string;
  showHelloWorld: boolean;
  requestId: string;
  name: string;
  email: string;
  successMessage: string;
  isValidForm: any;
  iframelink: any;
  request: any;
  button = true;
  errorData: any;
  token: TToken;
  originalLink: string;
  successfull = false;
  isPopupOpen = false;
  step: GuestStep = 'loading';
  signerName: string;
  signerSSN: string;
  signingUrl: SafeResourceUrl;
  private _disclosuresPollingInterval: any;

  documentTypes = [
    { label: 'US State ID', value: 'US State ID' },
    { label: 'US Driver License', value: 'US Driver’s License' },
    { label: 'US Passport', value: 'US Passport' },
    { label: 'International Passport', value: 'Passport' },
    { label: 'US Employment Authorization Card', value: 'US Employment Authorization Card' },
    { label: 'US Passport Card', value: 'US Passport Card' },
    { label: 'US Permanent Resident Card', value: 'US Permanent Resident Card' },
  ];
  selectedDocumentType: any;

  constructor(
    private _GuestBiometric: GuestBiometricService,
    private _route: ActivatedRoute,
    private _router: Router,
    private _notificationService: NotificationService,
    private _domSanitizer: DomSanitizer,
    private _authService: AuthenticationService,
    private _disclosuresService: DisclosuresService,
  ) {
    //private _dialogRef: MatDialogRef<GuestBiometricComponent>
    super();
    this.isLoading = true;
    //this.selectedDocumentType = this.documentTypes[0];
  }

  ngOnInit() {
    this._route.paramMap
      .pipe(
        switchMap((params) => {
          this.requestId = params.get('requestId');
          console.log('Request ID from route parameters:', this.requestId);
          return this._route.queryParamMap;
        }),
        switchMap((params) => {
          this.code = params.get('code');
          this.role = params.get('role');
          console.log('Code from query parameters:', this.code);

          return this._authService.loginByCode(this.code, this.role || '');
        }),
        catchError((error) => {
          this.error = 'Failed to fetch company data. Please try again later.';
          this.showHelloWorld = true;
          this._router.navigate(['/login']);
          return throwError(error);
        }),
      )
      .subscribe(
        (data) => {
          this.token = data as unknown as TToken;
          this.setCompanyLogo();
          this._resolveStep();
        },
        (error) => {
          console.error('Error:', error);
        },
      );
  }

  setCompanyLogo() {
    let logo: string | null = null;
    if (this.token.company.name === 'Boyd Gaming Corporation') {
      logo = 'boyd_gaming_logo.jpg';
    } else if (this.token.company.name === 'Pavilion Payments') {
      logo = 'pavilion_payments_logo.jpg';
    } else {
      logo = 'company_logo_placeholder.png';
    }
    this.token.company.logoName = logo;

  }
  getVerificationLink() {
    let observableRequest;
    if (!this.role || this.role != 'public') {
      observableRequest = this._GuestBiometric.getRequestWithRole(this.requestId, this.role);
    } else {
      observableRequest = this._GuestBiometric.getRequest(this.requestId);
    }
    observableRequest.subscribe((response) => {
      this.request = response;
      this.request = this.request.data[0]
      this._GuestBiometric
        .initiateBiometricVerification(
          this.request.id,
          this.request.username,
          this.selectedDocumentType,
          this.token.accessToken,
          this.role || 'public'
        )
        .pipe(
          takeUntil(this._destroy$),
          tap((response) => {
            this._operationId = response.operationId;
            this.originalLink = response.iframeLink + '&nc';
          }),
          map((response) => this._domSanitizer.bypassSecurityTrustResourceUrl(response.iframeLink)),
          finalize(() => (this.isLoading = false)),
        )
        .subscribe((link: SafeResourceUrl) => {
          this.link = link;
        });
    });
  }

  @HostListener('window:message', ['$event'])
  public onPostMessage(event: MessageEvent): void {
    if (event.data.pageName && event.data.success) {
      this.link = '';
      this.successfull = true;
      this.step = 'disclosure-signing';
      this._disclosuresService.markIdvCompleted(this.code, this.role).pipe(take(1)).subscribe();
    }
  }

  public onLoaded(): void {
    this.isLoading = false;
  }

  public close(): void {
    if (this.isLoading) {
      return;
    }
    this._notificationService.info('Biometric Verification Stopped');
  }

  private _isFailedPage(pageName: string): boolean {
    switch (pageName) {
      case 'transactionNotValidPage':
      case 'transactionMaxAttemptsPage':
      case 'verifiedMatchFailPage':
      case 'verifyDeclinedPage':
      case 'docScanResolutionTooLowPage':
      case 'videoDeviceNotFoundPage':
      case 'standardErrorPage':
      case 'defaultFailedPage':
        return true;
      default:
        return false;
    }
  }

  private _resolveStep() {
    this._disclosuresService.checkDisclosuresSigned(this.code, this.role).pipe(take(1)).subscribe((res) => {
      if (res.signed) {
        this.step = 'done';
      } else if (res.idv_completed) {
        this.step = 'disclosure-signing';
        if (res.created && res.disclosure) {
          this._processDisclosureResponse(res.disclosure);
        }
      } else {
        this.step = 'id-screening';
      }
    });
  }

  createDocument() {
    this._disclosuresService.createDisclosuresDocument(this.signerName, this.code, this.signerSSN, this.role).pipe(take(1)).subscribe((res) => {
      this._processDisclosureResponse(res);
    });
  }

  validSSN(): boolean {
    const ssnPattern = /^\d{3}-?\d{2}-?\d{4}$/;
    return ssnPattern.test(this.signerSSN);
  }

  getViewDocumentClass(): string {
    const disabled = !this.signerName || !this.validSSN();
    const classes = disabled ? 'btn-default disabled cursor-no-drop' : 'btn-primary cursor-pointer';
    return `border p-2 rounded-lg ${classes}`;
  }

  private _processDisclosureResponse(response: ICreateDisclosureResponse) {
    this.signingUrl = this._domSanitizer.bypassSecurityTrustResourceUrl(response.signing_url);
    this._disclosuresPollingInterval = setInterval(() => {
      this._disclosuresService.checkDisclosuresSigned(this.code, this.role).pipe(take(1)).subscribe((res) => {
        if (res.signed) {
          this.step = 'done';
          this.signingUrl = null;
          clearInterval(this._disclosuresPollingInterval);
        }
      });
    }, 5000);
  }

  ngOnDestroy() {
    super.ngOnDestroy();
    if (this._disclosuresPollingInterval) {
      clearInterval(this._disclosuresPollingInterval);
    }
  }

  onSelectDocumentType(event: MatRadioChange) {
    this.errorData = '';
    console.log('Selected Document Type:', event.value);
    this.selectedDocumentType = event.value;
  }
  confirmVerify(): void {
    if (this.selectedDocumentType) {
      this.button = false;
      this.getVerificationLink();
      this.isPopupOpen = false;
    } else {
      this.errorData = '* Please select any one option';
    }
  }
  backToPage(): void {
    this.button = true;
  }
  openPopup(): void {
    if (this.selectedDocumentType) {
      this.isPopupOpen = true;
    } else {
      this.errorData = '* Please select any one option';
    }
  }
  cancelBtn(): void {
    this.isPopupOpen = false;
  }
}
